export default __webpack_public_path__ + "static/media/404-image.471d9904.svg";